import { render, staticRenderFns } from "./CommitDraftBills.vue?vue&type=template&id=08de7db0&"
import script from "./CommitDraftBills.vue?vue&type=script&lang=js&"
export * from "./CommitDraftBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommitDraftBills.vue"
export default component.exports